import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UserService } from './user.service';
import { Service } from '../models/service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private api: ApiService, private userService: UserService) { }

  competences() {
    return this.api.get('/competences');
  }
  formations() {
    return this.api.get('/formations');
  }
  pays() {
    return this.api.get('/pays');
  }
  lastOffres() {
    return this.api.get('/offres');
  }

  findOffres(data) {
    return this.api.get('/findOffres?valeur=' + data);
  }

  findStageEmploi(data) {
    return this.api.get('/findStageEmploie');
  }

  getOffre(id) {
    return this.api.get('/detailOffre/' + id);
  }

  cvs(id: any) {
    return this.api.get('/cvs', {
      idPostulant: id
    });
  }

  disableCv(idCv: any) {
    return this.api.post('/disableCv', idCv);
  }

  disableElementCv(idElementCv: any) {
    return this.api.post('/disableElementCv', idElementCv);
  }

  candidatures(id: any) {
    return this.api.get('/candidatures', {
      idPostulant: id
    });
  }

  post(data: any) {
    return this.api.post('/candidater', data);
  }

  addCvFormCandidature(data: any) {
    return this.api.post('/addCvForCandidature', data);
  }


  addCv(data) {
    return this.api.post('/addCv', data);
  }

  contactUs(data) {
    return this.api.post('/contactUs', data);
  }

  editCv(data) {
    return this.api.post('/modifyCv', data);
  }

  sendToOpenStack(file: File, i: number) {
    let formdata = new FormData();
    formdata.append('file', file);
    console.log(formdata);
    return this.api.post('/openstack', formdata);
  }

}
